let smartAssistWidgetExpanded = false;
let smartAssistNudgeDisplayed = false;
let smartAssistNudgeDismissed = false;
let smartAssistScrollTimeoutId = null;
let smartAssistScrollActive = false;


window.addEventListener('scroll', () => {
    smartAssistScrollActive = false;
}, { passive: true });

document.addEventListener("DOMContentLoaded", (event) => {
  sessionStorage.removeItem('smartAssistNudgeClosed');
  initializeSmartAssistWidget();
});



function initializeSmartAssistWidget() {
  const smartAssistWidgetElement = document.querySelector('.smart_assist');
  
  if (!smartAssistWidgetElement) {
    console.warn('Smart Assist widget not found');
    return;
  }

  if (!document.getElementById('smartAssistOverlay')) {
    const smartAssistOverlayElement = document.createElement('div');
    smartAssistOverlayElement.className = 'smart_assist__overlay';
    smartAssistOverlayElement.id = 'smartAssistOverlay';
    smartAssistOverlayElement.addEventListener('click', closeSmartAssistWidget);
    document.body.appendChild(smartAssistOverlayElement);
  }

  if (!document.getElementById('smartAssistNudge')) {
    const smartAssistNudgeElement = document.createElement('div');
    smartAssistNudgeElement.className = 'smart_assist__nudge';
    smartAssistNudgeElement.id = 'smartAssistNudge';
    smartAssistNudgeElement.innerHTML = `
      <div class="smart_assist__nudge-btn-text">Need Help Buying?</div>
      <button class="smart_assist__nudge-close" onclick="dismissSmartAssistNudge()" type="button">×</button>
    `;
    
    const smartAssistContainer = smartAssistWidgetElement.querySelector('.smart_assist__container');
    const smartAssistExpanded = smartAssistWidgetElement.querySelector('.smart_assist__expanded');
    if (smartAssistContainer && smartAssistExpanded) {
      smartAssistContainer.insertBefore(smartAssistNudgeElement, smartAssistExpanded);
    }
  }

  setTimeout(() => {
    smartAssistWidgetElement.style.transition = 'all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
  }, 50);

  setTimeout(() => {
    smartAssistWidgetElement.style.transform = 'translateY(0)';
    smartAssistWidgetElement.style.opacity = '1';
    smartAssistWidgetElement.classList.add('smart_assist__widget-entrance');
  }, 100);

  setTimeout(() => {
    var isListVisible = document.querySelector('.smart_assist__toggle--expanded');
    if (!smartAssistNudgeDismissed && !sessionStorage.getItem('smartAssistNudgeClosed') && isListVisible == null) {
      displaySmartAssistNudge();
    }
  }, 13000);

  setupSmartAssistScrollBehavior();
  setupSmartAssistClickOutside();
}

function displaySmartAssistNudge() {
  const smartAssistNudgeElement = document.getElementById('smartAssistNudge');
  if (smartAssistNudgeElement) {
    smartAssistNudgeElement.classList.add('smart_assist__nudge--visible');
    smartAssistNudgeDisplayed = true;
  }
}

function dismissSmartAssistNudge() {
  const smartAssistNudgeElement = document.getElementById('smartAssistNudge');
  if (smartAssistNudgeElement) {
    smartAssistNudgeElement.classList.remove('smart_assist__nudge--visible');
    smartAssistNudgeDisplayed = false;
    smartAssistNudgeDismissed = true;    
    sessionStorage.setItem('smartAssistNudgeClosed', 'true');
    gaEvent('help_cancelled', ['smart_assist', '', '', '', '', ''], false);
  }
}

function toggleSmartAssistWidget() {
  const smartAssistExpandedPanel = document.getElementById('smartAssistExpanded');
  const smartAssistToggleButton = document.getElementById('smartAssistToggle');
  const smartAssistOverlayElement = document.getElementById('smartAssistOverlay');
  
  if (!smartAssistExpandedPanel || !smartAssistToggleButton) {
    console.warn('Required Smart Assist elements not found');
    return;
  }

  smartAssistWidgetExpanded = !smartAssistWidgetExpanded;
  
  if (smartAssistWidgetExpanded) {
    openSmartAssistWidget(smartAssistExpandedPanel, smartAssistToggleButton, smartAssistOverlayElement);
  } else {
    closeSmartAssistWidget();
  }
}

function openSmartAssistWidget(expandedPanel, toggleButton, overlayElement) {
  expandedPanel.classList.add('smart_assist__expanded--visible');
  toggleButton.classList.add('smart_assist__toggle--expanded');
  
  if (overlayElement) {
    overlayElement.classList.add('smart_assist__overlay--visible');
  }
  
  if (smartAssistNudgeDisplayed) {
    dismissSmartAssistNudge();
  }
  
  setTimeout(() => {
    const smartAssistOptionElements = expandedPanel.querySelectorAll('.smart_assist__option');
    smartAssistOptionElements.forEach(optionElement => {
      optionElement.classList.add('smart_assist__option--animate');
    });
  }, 100);

  gaEvent('smart_assist', ['','','','','',''], false)
}

function closeSmartAssistWidget() {
  const smartAssistExpandedPanel = document.getElementById('smartAssistExpanded');
  const smartAssistToggleButton = document.getElementById('smartAssistToggle');
  const smartAssistOverlayElement = document.getElementById('smartAssistOverlay');
  
  if (!smartAssistExpandedPanel || !smartAssistToggleButton) return;

  const smartAssistOptionElements = smartAssistExpandedPanel.querySelectorAll('.smart_assist__option');
  smartAssistOptionElements.forEach(optionElement => {
    optionElement.classList.remove('smart_assist__option--animate');
  });
  
  smartAssistExpandedPanel.classList.remove('smart_assist__expanded--visible');
  smartAssistToggleButton.classList.remove('smart_assist__toggle--expanded');
  
  if (smartAssistOverlayElement) {
    smartAssistOverlayElement.classList.remove('smart_assist__overlay--visible');
  }
  
  smartAssistWidgetExpanded = false;
  gaEvent('sa_cancelled', ['','','','','',''], false)
}

function setupSmartAssistScrollBehavior() {
  const smartAssistWidgetElement = document.querySelector('.smart_assist');
  if (!smartAssistWidgetElement) return;
  
  let smartAssistScrollTicking = false;
  
  function updateSmartAssistScrollState() {
    if (window.innerWidth <= 768) {
      if (!smartAssistScrollActive) {
        // smartAssistWidgetElement.style.setProperty('transition', 'all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)', 'important');
        
        // smartAssistWidgetElement.style.setProperty('transform', 'translateY(100px)', 'important');
        // smartAssistWidgetElement.style.setProperty('opacity', '0', 'important');
        smartAssistScrollActive = true;
        
        if (smartAssistWidgetExpanded) {
          closeSmartAssistWidget();
        }
      }
      
      clearTimeout(smartAssistScrollTimeoutId);
      
      const smartAssistHasBeenShown = smartAssistWidgetElement.classList.contains('smart_assist__widget-entrance');
      
      const smartAssistDelayTime = smartAssistHasBeenShown ? 1000 : 3000;
      
      smartAssistScrollTimeoutId = setTimeout(() => {
        smartAssistWidgetElement.style.setProperty('transition', 'all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)', 'important');
        smartAssistWidgetElement.style.setProperty('transform', 'translateY(0)', 'important');
        smartAssistWidgetElement.style.setProperty('opacity', '1', 'important');
        smartAssistScrollActive = false;
      }, smartAssistDelayTime);
    } else {
      if (smartAssistWidgetExpanded) {
        closeSmartAssistWidget();
      }
    }
    
    smartAssistScrollTicking = false;
  }
  
  window.addEventListener('scroll', () => {
    if (!smartAssistScrollTicking) {
      requestAnimationFrame(updateSmartAssistScrollState);
      smartAssistScrollTicking = true;
    }
  }, { passive: true });
  
  window.addEventListener('resize', () => {
    if (window.innerWidth > 768 && smartAssistScrollActive) {
      clearTimeout(smartAssistScrollTimeoutId);
      smartAssistWidgetElement.style.setProperty('transition', 'all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)', 'important');
      smartAssistWidgetElement.style.setProperty('transform', 'translateY(0)', 'important');
      smartAssistWidgetElement.style.setProperty('opacity', '1', 'important');
      smartAssistScrollActive = false;
    }
  });
}

function setupSmartAssistClickOutside() {
  const smartAssistOverlayElement = document.getElementById('smartAssistOverlay');
  if (smartAssistOverlayElement) {
    smartAssistOverlayElement.addEventListener('click', closeSmartAssistWidget);
  }
}

document.querySelectorAll('.dev_ga-fire-ga-smart-assist-widget').forEach(element => {
  element.addEventListener('click', function() {
    const eventname = this.dataset.eventname;
    const param1 = this.dataset.param1 ?? '';
    const param2 = this.dataset.param2 ?? '';
    const param3 = this.dataset.param3 ?? '';
    const param4 = this.dataset.param4 ?? '';
    const param5 = this.dataset.param5 ?? '';
    const param6 = this.dataset.param6 ?? '';
    
    if(eventname){
      gaEvent(eventname, [param1, param2, param3, param4, param5, param6], false);
    }
  });
});

// Upate link when mobile view
if (window.innerWidth < 768) {
    let itemsAll = document.querySelectorAll('a[data-redirectionmobile]');
    itemsAll.forEach(item => {
        const mobileUrl = item.getAttribute('data-redirectionmobile');
        if (mobileUrl) {
            item.href = mobileUrl;
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function(){   
    const nudge = document.querySelector('#smartAssistNudge .smart_assist__nudge-btn-text');
    const toggle = document.getElementById('smartAssistToggle');
      if (nudge && toggle) {
          nudge.addEventListener('click', () => {
            toggle.click();
          });
      }
    },4000);   
});